import { memo, useCallback } from 'react'
import { useDispatch, useSelector } from '@tabeeb/store'
import { setContentsForSharing } from '@tabeeb/modules/contentSharings/actions'
import { getContentSearchState } from '@tabeeb/modules/contentSharings/selectors'
import { SearchResultRowBtn } from '@tabeeb/modules/contentSharings/constants/enums'
import { Stack } from '@collaborate-health/uikit'
import SearchContentResultItem from '../SearchContentResultItem'

const SearchContentResult = () => {
  const dispatch = useDispatch()
  const { contentsList } = useSelector(getContentSearchState)

  const _handleContentClick = useCallback(
    (content) => {
      dispatch(setContentsForSharing([content]))
    },
    [dispatch]
  )

  return (
    <Stack spacing={0.5}>
      {contentsList.map((content) => (
        <SearchContentResultItem
          content={content}
          button={SearchResultRowBtn.Select}
          handleButtonClick={_handleContentClick}
          key={content.Id}
        />
      ))}
    </Stack>
  )
}

export default memo(SearchContentResult)

